import { Injectable } from '@angular/core';

import {Subject} from 'rxjs/Subject';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

import {User} from '../models/user';
import {Observable} from 'rxjs/Observable';
import {Message} from '../models/message';

@Injectable()
export class UserService {
  users: User[];
  editingUsers: User[];
  cells: Subject<User[]>;

  constructor() {
      this.init();
  }

  init() {
      this.users = (this.users) ? this.users.splice(0, this.users.length) : [];
      this.editingUsers = (this.editingUsers) ? this.editingUsers.splice(0, this.editingUsers.length) : [];
      if (this.cells) {
          this.cells.next(null);
      } else {
          this.cells = new BehaviorSubject<User[]>(null);
      }
  }

  public addUser(message: Message): void {
      if (this.users.filter(u => u.username === message.user).length === 0) {
          this.users.push(this.createUser(message));
      }
  }

  public removeUser(username: string): void {
      this.users = this.users.filter(u => u.username !== username);
      this.editingUsers = this.editingUsers.filter(u => u.username !== username);
      this.cells.next(this.editingUsers);
  }

  public getEditing(): Observable<User[]> {
    return this.cells.asObservable();
  }

  private createUser(message: Message): User {
    const user = new User();
    user.initialize();
    user.username = message.user;
    user.color = this.getRandomColor();
    return user;
  }

  public setColumns(message: Message, isEditing: boolean): void {
      let user: User = null;
      const users = this.users.filter(u => u.username === message.user);
      if (users.length === 0) {
          user = this.createUser(message);
          this.users.push(user);
      } else {
          user = users[0];
          user.initialize();
      }
      user.isEditing = isEditing;

      message.data.details.forEach((item) => {
          user.level = message.data.level;
          user.portfolioId = message.data.portfolioId;
          user.row = message.data.subRow;
          user.key = message.data.key;
          user.date.push(item.date);
          user.columns.push(item.index);
      });

      this.editingUsers.push(user);
      this.cells.next(this.editingUsers);
  }

  public unsetColumns(username: string): void {
      this.editingUsers = this.editingUsers.filter(u => u.username !== username);
      this.cells.next(this.editingUsers);
  }

  private getRandomColor() {
    const letters = '0123456789ABCDEF'.split('');
    let color = '#';
    for (let i = 0; i < 6; i++ ) {
      color += letters[Math.round(Math.random() * 15)];
    }
    return color;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/user.service.ts